import QuickOperateButton from './QuickOperateButton';

const QuickLinks = ({ variant = 'default', onLinkNavigate, collapsed = false, onToggleCollapse }) => {
	return (
		<QuickOperateButton
			variant={variant}
			onLinkNavigate={onLinkNavigate}
			collapsed={variant === 'drawer' ? false : collapsed}
			onToggleCollapse={variant === 'drawer' ? undefined : onToggleCollapse}
		/>
	);
};

export default QuickLinks;
